module.exports = __webpack_public_path__ + "319d5590b5ee03052a0118dfcf1032bc.jpg";